<div class="vc-modal__innerContainer authenticationModal">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>
  <div class="vc-modal__title" i18n="@@PRODUCT.DETAILS.AUTHENTICATION.KNOW_MORE_MODAL.TITLE">Authentication fees</div>
  <div class="vc-modal__content authenticationModal__content">
    <ul class="authenticationModal__itemList">
      <li class="authenticationModal__item">
        <img class="authenticationModal__item__icon" src="/assets/svg/diamond-check.svg" alt="" />
        <div class="authenticationModal__item__content">
          <h3
            class="authenticationModal__item__title"
            i18n="@@PRODUCT.DETAILS.AUTHENTICATION.KNOW_MORE_MODAL.AUTHENTICATION.TITLE"
          >
            Authentication and verification
          </h3>
          <div class="authenticationModal__item__description">
            <p i18n="@@PRODUCT.DETAILS.AUTHENTICATION.KNOW_MORE_MODAL.AUTHENTICATION.DESCRIPTION1">
              Sold items are physically verified and authenticated by our experts.
            </p>
            <p i18n="@@PRODUCT.DETAILS.AUTHENTICATION.KNOW_MORE_MODAL.AUTHENTICATION.DESCRIPTION2">
              Vestiaire Collective has no association and/or affiliation with the brands whose products are offered for
              sale on its website.
            </p>
            <p i18n="@@PRODUCT.DETAILS.AUTHENTICATION.KNOW_MORE_MODAL.AUTHENTICATION.DESCRIPTION3">
              The authentication of said products is performed independently by Vestiaire Collective.
            </p>
          </div>
        </div>
      </li>

      <li class="authenticationModal__item">
        <img class="authenticationModal__item__icon" src="/assets/images/commissionPage/picto-dollar.svg" alt="" />
        <div class="authenticationModal__item__content">
          <h3
            class="authenticationModal__item__title"
            i18n="@@PRODUCT.DETAILS.AUTHENTICATION.KNOW_MORE_MODAL.REFUND.TITLE"
          >
            Guaranteed refund
          </h3>
          <div
            class="authenticationModal__item__description"
            i18n="@@PRODUCT.DETAILS.AUTHENTICATION.KNOW_MORE_MODAL.REFUND.DESCRIPTION"
          >
            Guaranteed 100% refund when an item does not comply with the description given by the seller or in the event
            of it being misplaced by the carrier.
          </div>
        </div>
      </li>

      <li class="authenticationModal__item">
        <img class="authenticationModal__item__icon" src="/assets/images/commissionPage/picto-phone.svg" alt="" />
        <div class="authenticationModal__item__content">
          <h3
            class="authenticationModal__item__title"
            i18n="@@PRODUCT.DETAILS.AUTHENTICATION.KNOW_MORE_MODAL.CUSTOMER_SERVICE.TITLE"
          >
            Customer Care at your disposal
          </h3>
          <div
            class="authenticationModal__item__description"
            i18n="@@PRODUCT.DETAILS.AUTHENTICATION.KNOW_MORE_MODAL.CUSTOMER_SERVICE.DESCRIPTION"
          >
            Via phone, email and Chat.
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
